module.exports = __webpack_public_path__ + "img/bottle-glass.bd043471.png";